import { faFacebookF, faFlickr, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faArrowDown, faAt, faBars, faCampground, faChevronLeft, faChevronRight, faChevronUp, faClock, faDownload, faFileInvoice, faFilePdf, faFilter, faGlobe, faHome, faInfoCircle, faKeyboard, faList, faLock, faMapMarkerAlt, faPaperPlane, faPencilAlt, faPhone, faPlus, faShoppingCart, faSignature, faSignOutAlt, faSpinner, faTimes, faUser } from "@fortawesome/free-solid-svg-icons";

const IconList = {
    home: faHome,
    about: faInfoCircle,
    contact: faPhone,
    menuToggle: faBars,
    close: faTimes,
    name: faSignature,
    email: faAt,
    text: faKeyboard,
    send: faPaperPlane,
    next: faChevronRight,
    previous: faChevronLeft,
    facebook: faFacebookF,
    instagram: faInstagram,
    flickr: faFlickr,
    address: faMapMarkerAlt,
    phone: faPhone,
    user: faUser,
    clock: faClock,
    tiktok: faTiktok,
    tent: faCampground,
    up: faChevronUp,
    spinner: faSpinner,
    post: faList,
    password: faLock,
    webApplication: faGlobe,
    logout: faSignOutAlt,
    edit: faPencilAlt,
    add: faPlus,
    filter: faFilter,
    pdf: faFilePdf,
    arrowDown: faArrowDown,
    location: faMapMarkerAlt,
    cart: faShoppingCart
}

export default IconList